// 轮询
import checkOrder from './check-order'

let loopTimers = []

/**
 * 开启订单轮询
 *
 * @param {String} orderId  订单id
 * @param {Number} interval 轮询间隔时长, 默认1s, 传参单位为毫秒
 * @returns {Promise} resolve 为订单成功
 */
export function startLoopOrder (orderId, interval = 1000) {
  return new Promise(resolve => {
    stopLoopOrder(orderId)
    const todo = async function () {
      // 查询订单状态
      const result = await checkOrder(orderId)
      if (result) {
        stopLoopOrder(orderId)
        resolve()
      }
    }
    const timer = setInterval(todo, interval)
    loopTimers.push({ orderId, timer })
    todo() // 先执行一次, 建议开启轮询时先给个 500ms 的延迟
  })
}

/**
 * 关闭订单轮询
 *
 * @param {String} orderId 订单id
 */
export function stopLoopOrder (orderId) {
  for (let i = 0; i < loopTimers.length; i++) {
    const item = loopTimers[i]
    if (item.orderId === orderId) {
      clearInterval(item.timer)
      loopTimers.splice(i, 1)
      break
    }
  }
}

/**
 * 关闭所有订单轮询
 */
export function stopAllLoopOrder () {
  loopTimers.forEach(({ timer }) => clearInterval(timer))
  loopTimers = []
}
